<template>
    <div class="nosotros">
        <Navbar />
        <link rel="stylesheet"
              href="https://cdnjs.cloudflare.com/ajax/libs/animate.css/4.1.1/animate.min.css" />
        <section id="section-banner-services" class="section-banner-services">
            <div class="container">
                <div class="row d-flex justify-content-center">
                    <div class="col-9 text-center ajuste-textos animate__animated animate__fadeInLeft">
                        <h1 class="textos subtitulos-principales blanco bold">NUESTROS SERVICIOS</h1>
                        <p class="textos subtitulos-intermedios-sec-ajustes light blanco pb-md-3">Soluciones diseñadas para tu tranquilidad y la de tus clientes o usuarios.</p>
                    </div>
                </div>
            </div>
        </section>
        <section id="flechas-generales">
            <div class="flecha-down wow animate__animated animate__fadeInDown animate__infinite	infinite animate__slow">
                <img src="../assets/home/flecha-abajo.png" alt="">
            </div>
        </section>
        <section id="section-frase" class="mission-textura">
            <div class="container py-md-5 py-5">
                <div class="row py-md-5 py-5 d-flex justify-content-center">
                    <div class="col-md-12 text-center py-md-3 py-3">
                        <h2 class="textos subtitulos-principales bold blanco pb-md-5">ESTÁS EN <span class="textos subtitulos-principales bold rojo pb-md-5">BUENAS MANOS</span></h2>
                        <p class="textos subtitulos-intermedios-sec light blanco pb-md-3">Hemos logrado consolidar un portafolio amplio de productos jurídicos y no jurídicos diseñado para resolver de manera eficiente todas las necesidades de asistencia que nuestros clientes buscan.</p>
                    </div>
                </div>
            </div>
        </section>

        <div>
            <section id="section-services" class="py-4">
                <div class="container">
                    <div class="row">
                        <div class="col-md-12 text-center d-flex justify-content-center  wow animate__animated animate__fadeInDown">
                            <div class="estilos-listados-titulo bg-azulFuerte">
                                <div class="d-flex justify-content-center align-items-center">
                                    <div><img src="../assets/servicios/iconos-juridicos/simbolo.png" alt="" id="estudios-img-2-" class="img-fluid clase-simbolo" /></div>
                                    <div><h4 class="textos parrafos-principales light blanco">Servicios jurídicos</h4></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-md-12 text-center d-flex justify-content-center  wow animate__animated animate__fadeInDown" v-on:click="sevJurPoder=!sevJurPoder;">
                    <div class="estilos-listados bg-rojo" aria-expanded="false" aria-controls="collapseExample">
                        <a id="estudios-3 clase-images" data-toggle="collapse" role="button" aria-expanded="false" aria-controls="collapseExample">
                            <div class="d-flex justify-content-between align-items-center">
                                <div><img src="../assets/servicios/iconos-juridicos/icon1.png" alt="" id="estudios-img-2-" class="img-fluid icon-servicios" /></div>
                                <div><h4 class="textos parrafos-principales light blanco"><img src="../assets/servicios/icon-par.png" alt="" /> Poder de Acción Real</h4></div>
                                <div><img src="../assets/servicios/mas.png" alt="" id="estudios-img-2" class="" /></div>
                            </div>
                        </a>
                    </div>
                </div>
                <div class="col-md-12 text-center d-flex justify-content-center" v-if="sevJurPoder">
                    <div class="estilo-caja-collapse">
                        <div class=" text-left p-4">
                            <p class="textos parrafos-intermedios negro light">
                                A través de un poder notarial, representamos legalmente a flotillas de unidades ante la
                                autoridad. También administramos un fondo para el pago de grúas, multas y corralones,
                                entre otros.
                            </p>
                            <p>
                                <router-link class="nav-link" :to="{name: 'Par'}">
                                    <img src="../assets/servicios/boton.png" class="img-fluid icon-boton" alt="" />
                                </router-link>
                            </p>
                        </div>
                    </div>
                </div>
                <div class="col-md-12 text-center d-flex justify-content-center  wow animate__animated animate__fadeInDown" v-on:click="sevJurLegal=!sevJurLegal;">
                    <div class="estilos-listados bg-rojo">
                        <a id="estudios-3 clase-images" data-toggle="collapse" role="button" aria-expanded="false" aria-controls="collapseExample">
                            <div class="d-flex justify-content-between align-items-center">
                                <div><img src="../assets/servicios/iconos-juridicos/icon2.png" alt="" id="estudios-img-3-" class="img-fluid icon-servicios" /></div>
                                <div><h4 class="textos parrafos-principales light blanco">Legal a automovilistas</h4></div>
                                <div><img src="../assets/servicios/mas.png" alt="" id="estudios-img-3" class="" /></div>
                            </div>
                        </a>
                    </div>
                </div>
                <div class="col-md-12 text-center d-flex justify-content-center" v-if="sevJurLegal">
                    <div class="estilo-caja-collapse">
                        <div class="text-left p-4">
                            <p class="textos parrafos-intermedios negro light">Nos ocupamos de la defensa, asesoría y respaldo del conductor, desde el inicio del incidente hasta la conclusión total.</p>
                        </div>
                    </div>
                </div>
                <div class="col-md-12 text-center d-flex justify-content-center  wow animate__animated animate__fadeInDown" v-on:click="sevJurProfecional=!sevJurProfecional;">
                    <div class="estilos-listados bg-rojo">
                        <a id="estudios-3 clase-images" data-toggle="collapse" role="button" aria-expanded="false" aria-controls="collapseExample">
                            <div class="d-flex justify-content-between align-items-center">
                                <div><img src="../assets/servicios/iconos-juridicos/icon3.png" alt="" id="estudios-img-4-" class="img-fluid icon-servicios" /></div>
                                <div><h4 class="textos parrafos-principales light blanco">Legal por responsabilidad profesional</h4></div>
                                <div><img src="../assets/servicios/mas.png" alt="" id="estudios-img-4" /></div>
                            </div>
                        </a>
                    </div>
                </div>
                <div class="col-md-12 text-center d-flex justify-content-center" v-if="sevJurProfecional">
                    <div class="estilo-caja-collapse">
                        <div class="text-left p-4">
                            <p class="textos parrafos-intermedios negro light">Defendemos a profesionistas sujetos a procesos administrativos, penales o civiles con motivo de la responsabilidad civil que pudieran derivarse del ejercicio de su actividad profesional. </p>
                        </div>
                    </div>
                </div>
                <div class="col-md-12 text-center d-flex justify-content-center align-items-center  wow animate__animated animate__fadeInDown" v-on:click="sevJurEmergencias=!sevJurEmergencias;">
                    <div class="estilos-listados bg-rojo">
                        <a id="estudios-5 clase-images" data-toggle="collapse" role="button" aria-expanded="false" aria-controls="collapseExample">
                            <div class="d-flex justify-content-between align-items-center">
                                <div><img src="../assets/servicios/iconos-juridicos/icon4.png" alt="" id="estudios-img-5-" class="img-fluid icon-servicios" /></div>
                                <div><h4 class="textos parrafos-principales light blanco">Emergencias Legales</h4></div>
                                <div><img src="../assets/servicios/mas.png" alt="" id="estudios-img-5" /></div>
                            </div>
                        </a>
                    </div>
                </div>
                <div class="col-md-12 text-center d-flex justify-content-center" v-if="sevJurEmergencias">
                    <div class="estilo-caja-collapse">
                        <div class="text-left p-4">
                            <p class="textos parrafos-intermedios negro light">Brindamos asesoría en cualquier rama del Derecho y prestamos asistencia para los casos en que se requieran denuncias de alta prioridad por robo, asalto o intento de extorsión.</p>
                        </div>
                    </div>
                </div>
                <div class="col-md-12 text-center d-flex justify-content-center  wow animate__animated animate__fadeInDown" v-on:click="sevJurDefensas=!sevJurDefensas;">
                    <div class="estilos-listados bg-rojo">
                        <a id="estudios-6 clase-images" data-toggle="collapse" role="button" aria-expanded="false" aria-controls="collapseExample">
                            <div class="d-flex justify-content-between align-items-center">
                                <div><img src="../assets/servicios/iconos-juridicos/icon5.png" alt="" id="estudios-img-6-" class="img-fluid icon-servicios" /></div>
                                <div><h4 class="textos parrafos-principales light blanco">Defensa Legal en cobertura de daños</h4></div>
                                <div><img src="../assets/servicios/mas.png" alt="" id="estudios-img-6" /></div>
                            </div>
                        </a>
                    </div>
                </div>
                <div class="col-md-12 text-center d-flex justify-content-center" v-if="sevJurDefensas">
                    <div class="estilo-caja-collapse">
                        <div class="text-left p-4">
                            <p class="textos parrafos-intermedios negro light">Asesoría jurídica por cualquier tipo de daños diversos que se puedan producir en personas o bienes muebles o inmuebles, derivados de un accidente.</p>
                        </div>
                    </div>
                </div>
                <div class="col-md-12 text-center d-flex justify-content-center  wow animate__animated animate__fadeInDown">
                    <div class="estilos-listados-titulo bg-azulFuerte">
                        <div class="d-flex justify-content-center align-items-center">
                            <div><img src="../assets/servicios/iconos-no/icono.png" alt="" id="estudios-img-2-" class="img-fluid " /></div>
                            <div><h4 class="textos parrafos-principales light blanco">Servicios No jurídicos</h4></div>
                        </div>
                    </div>
                </div>
                <div class="col-md-12 text-center d-flex justify-content-center  wow animate__animated animate__fadeInDown" v-on:click="sevAuto=!sevAuto;">
                    <div class="estilos-listados bg-rojo">
                        <a id="estudios-7 clase-images" data-toggle="collapse" role="button" aria-expanded="false" aria-controls="collapseExample">
                            <div class="d-flex justify-content-between align-items-center">
                                <div><img src="../assets/servicios/iconos-no/1.png" alt="" id="estudios-img-7-" class="img-fluid icon-servicios " /></div>
                                <div><h4 class="textos parrafos-principales light blanco">Auto Sustituto</h4></div>
                                <div><img src="../assets/servicios/mas.png" alt="" id="estudios-img-7" /></div>
                            </div>
                        </a>
                    </div>
                </div>
                <div class="col-md-12 text-center d-flex justify-content-center" v-if="sevAuto">
                    <div class="estilo-caja-collapse">
                        <div class="text-left p-4">
                            <p class="textos parrafos-intermedios negro light">Contamos con  la opción de ofrecer un auto de respaldo en caso de un accidente o robo, durante un periodo establecido.</p>
                        </div>
                    </div>
                </div>
                <div class="col-md-12 text-center d-flex justify-content-center  wow animate__animated animate__fadeInDown" v-on:click="sevHogar=!sevHogar;">
                    <div class="estilos-listados bg-rojo">
                        <a id="estudios-8 clase-images" data-toggle="collapse" role="button" aria-expanded="false" aria-controls="collapseExample">
                            <div class="d-flex justify-content-between align-items-center">
                                <div><img src="../assets/servicios/iconos-no/i2.png" alt="" id="estudios-img-8-" class="img-fluid icon-servicios" /></div>
                                <div><h4 class="textos parrafos-principales light blanco">Asistencia en el Hogar </h4></div>
                                <div><img src="../assets/servicios/mas.png" alt="" id="estudios-img-8" /></div>
                            </div>
                        </a>
                    </div>
                </div>
                <div class="col-md-12 text-center d-flex justify-content-center" v-if="sevHogar">
                    <div class="estilo-caja-collapse">
                        <div class="text-left p-4">
                            <p class="textos parrafos-intermedios negro light">Enviamos, coordinamos y supervisamos servicios de emergencia en el hogar como plomería, cerrajería, electricidad, etcétera.</p>
                        </div>
                    </div>
                </div>

                <div class="col-md-12 text-center d-flex justify-content-center  wow animate__animated animate__fadeInDown" v-on:click="sevVial=!sevVial;">
                    <div class="estilos-listados bg-rojo">
                        <a id="estudios-1 clase-images" data-toggle="collapse" role="button" aria-expanded="false" aria-controls="collapseExample">
                            <div class="d-flex justify-content-between align-items-center">
                                <div><img src="../assets/servicios/iconos-no/i3.png" alt="" id="estudios-img-1-" class="img-fluid icon-servicios" /></div>
                                <div><h4 class="textos parrafos-principales light blanco">Auxilio Vial y Asistencia en Viajes </h4></div>
                                <div><img src="../assets/servicios/mas.png" alt="" id="estudios-img-1" /></div>
                            </div>
                        </a>
                    </div>
                </div>
                <div class="col-md-12 text-left d-flex justify-content-center" v-if="sevVial">
                    <div class="estilo-caja-collapse">
                        <div class="text-left p-4">
                            <p class="textos parrafos-intermedios negro light">Servicios de grúa, suministro de gasolina, paso de corriente y cambio del neumático. Además, en caso de emergencias en el país y en el extranjero: traslado por enfermedad, referencia de talleres, transporte alterno, entre otros.</p>
                        </div>
                    </div>
                </div>
                <div class="col-md-12 text-center d-flex justify-content-center  wow animate__animated animate__fadeInDown" v-on:click="sevMedicas=!sevMedicas;">
                    <div class="estilos-listados bg-rojo">
                        <a id="estudios-1 clase-images" data-toggle="collapse" role="button" aria-expanded="false" aria-controls="collapseExample">
                            <div class="d-flex justify-content-between align-items-center">
                                <div><img src="../assets/servicios/iconos-no/i4.png" alt="" id="estudios-img-1-" class="img-fluid icon-servicios" /></div>
                                <div><h4 class="textos parrafos-principales light blanco">Referencias médicas y ambulancias</h4></div>
                                <div><img src="../assets/servicios/mas.png" alt="" id="estudios-img-1" /></div>
                            </div>
                        </a>
                    </div>
                </div>
                <div class="col-md-12 text-left d-flex justify-content-center" v-if="sevMedicas">
                    <div class="estilo-caja-collapse">
                        <div class="text-left p-4">
                            <p class="textos parrafos-intermedios negro light">En caso de una emergencia de salud, brindamos asesoría sobre referencias médicas para que el usuario elija la mejor opción, así como el envío de ambulancia si es necesario. </p>
                        </div>
                    </div>
                </div>
                <div class="col-md-12 text-center d-flex justify-content-center  wow animate__animated animate__fadeInDown" v-on:click="sevPoliza=!sevPoliza;">
                    <div class="estilos-listados bg-rojo">
                        <a id="estudios-1 clase-images" data-toggle="collapse" role="button" aria-expanded="false" aria-controls="collapseExample">
                            <div class="d-flex justify-content-between align-items-center">
                                <div><img src="../assets/servicios/iconos-no/5.png" alt="" id="estudios-img-1-" class="img-fluid icon-servicios" /></div>
                                <div><h4 class="textos parrafos-principales light blanco">Asistencia Pólizas Vida</h4></div>
                                <div><img src="../assets/servicios/mas.png" alt="" id="estudios-img-1" /></div>
                            </div>
                        </a>
                    </div>
                </div>
                <div class="col-md-12 text-left d-flex justify-content-center" v-if="sevPoliza">
                    <div class="estilo-caja-collapse">
                        <div class="text-left p-4">
                            <p class="textos parrafos-intermedios negro light">Servicios de grúa, suministro de gasolina, paso de corriente y cambio del neumático. Además, en caso de emergencias en el país y en el extranjero: traslado por enfermedad, referencia de talleres, transporte alterno, entre otros.</p>
                        </div>
                    </div>
                </div>
                <div class="col-md-12 text-center d-flex justify-content-center  wow animate__animated animate__fadeInDown" v-on:click="sevGMM=!sevGMM;">
                    <div class="estilos-listados bg-rojo">
                        <a id="estudios-1 clase-images" data-toggle="collapse" role="button" aria-expanded="false" aria-controls="collapseExample">
                            <div class="d-flex justify-content-between align-items-center">
                                <div><img src="../assets/servicios/iconos-no/i6.png" alt="" id="estudios-img-1-" class="img-fluid icon-servicios" /></div>
                                <div><h4 class="textos parrafos-principales light blanco">Pólizas de vida GMM</h4></div>
                                <div><img src="../assets/servicios/mas.png" alt="" id="estudios-img-1" /></div>
                            </div>
                        </a>
                    </div>
                </div>
                <div class="col-md-12 text-left d-flex justify-content-center" v-if="sevGMM">
                    <div class="estilo-caja-collapse">
                        <div class="text-left p-4">
                            <p class="textos parrafos-intermedios negro light">Gestionamos el envío de restos humanos brindando servicios de recolección del cuerpo, embalsamiento, repatriación, trámites necesarios, transportación y referencias médicas.</p>
                        </div>
                    </div>
                </div>
                <div class="col-md-12 text-center d-flex justify-content-center  wow animate__animated animate__fadeInDown" v-on:click="sevPymes=!sevPymes;">
                    <div class="estilos-listados bg-rojo">
                        <a id="estudios-1 clase-images" data-toggle="collapse" role="button" aria-expanded="false" aria-controls="collapseExample">
                            <div class="d-flex justify-content-between align-items-center">
                                <div><img src="../assets/servicios/iconos-no/7.png" alt="" id="estudios-img-1-" class="img-fluid icon-servicios" /></div>
                                <div><h4 class="textos parrafos-principales light blanco">Asistencia para PYME´S</h4></div>
                                <div><img src="../assets/servicios/mas.png" alt="" id="estudios-img-1" /></div>
                            </div>
                        </a>
                    </div>
                </div>
                <div class="col-md-12 text-left d-flex justify-content-center" v-if="sevPymes">
                    <div class="estilo-caja-collapse">
                        <div class="text-left p-4">
                            <p class="textos parrafos-intermedios negro light">Asistencia para negocios o pequeñas empresas en consultas legales de cualquier tipo, permisos y licencias, asistencia técnica de emergencia y apoyo en: Plomería, Electricidad, Cerrajería, Vidriería, Pintura, Carpintería, Albañilería, Arquitectura, etc.</p>
                        </div>
                    </div>
                </div>
                <div class="col-md-12 text-center d-flex justify-content-center  wow animate__animated animate__fadeInDown" v-on:click="sevCabina=!sevCabina;">
                    <div class="estilos-listados bg-rojo">
                        <a id="estudios-1 clase-images" data-toggle="collapse" role="button" aria-expanded="false" aria-controls="collapseExample">
                            <div class="d-flex justify-content-between align-items-center">
                                <div><img src="../assets/servicios/iconos-no/i8.png" alt="" id="estudios-img-1-" class="img-fluid icon-servicios" /></div>
                                <div><h4 class="textos parrafos-principales light blanco">Cabina de Contacto Único </h4></div>
                                <div><img src="../assets/servicios/mas.png" alt="" id="estudios-img-1" /></div>
                            </div>
                        </a>
                    </div>
                </div>
                <div class="col-md-12 text-left d-flex justify-content-center" v-if="sevCabina">
                    <div class="estilo-caja-collapse">
                        <div class="text-left p-4">
                            <p class="textos parrafos-intermedios negro light">Call Center adaptable a las necesidades del cliente, a través del cual se realiza una llamada única en caso de siniestro y nosotros realizamos los enlaces necesarios con la aseguradora, empresa, contratante, etc.</p>
                        </div>
                    </div>
                </div>

            </section>
            <SecClientes />
            <SecAusa />
        </div>


        <Footer />
    </div>
</template>

<script>
// @ is an alias to /src

    import Navbar from './shared/Navbar/Navbar.vue';
    import Footer from './shared/footer/Footer.vue';
    import SecClientes from '../views/SecClientes.vue';
    import SecAusa from '../views/SecAusa.vue';
    

export default {
    name: "Nosotros",
        components: {
            Navbar,
            Footer,
            SecClientes,
            SecAusa

    },
    data() {
        return {
            sevJurPoder: false,
            sevJurLegal: false,
            sevJurProfecional: false,
            sevJurEmergencias: false,
            sevJurDefensas: false,
            sevAuto: false,
            sevHogar: false,
            sevVial: false,
            sevMedicas: false,
            sevPoliza: false,
            sevGMM: false,
            sevPymes: false,
            sevCabina: false,


        }
    }, 
    methods: {
        cambio(){
            console.log("enttra en clic");
            this.sevJurPoder=!this.sevJurPoder;
            console.log(this.sevJurPoder);

        }
    },
        mounted() {
            window.scrollTo({ top: 0, behavior: 'smooth' });

    }
};
</script>

<style scoped>
    @import "../assets/template/css/generals.css";
    @import "../assets/template/css/HomaMedia.css";
    .nosotros-banner {
        min-height: 650px;
        background-size: cover;
        background-position: 50%;
        background-repeat: no-repeat;
        background-image: url("../assets/home/banner-nosotros-01.png");
    }
    .ajuste-textos {
        padding-top: 180px;
    }
    .mission-textura {
        background-image: url("../assets/adn/textura.png");
    }      
.clase-simbolo{
    width: 100%;
    max-width: 50px;
}
.clase-images{
    font-size: 25px;
    color: #ffffff; 
}
#section-services{
    background-color: #f8fafd;
}
.estilos-listados-titulo {
    width: 65%;
    background-size: cover;
    background-position: center center;
    background-repeat: no-repeat;
    margin-bottom: 10px;
    margin-top: 10px;
    border-radius: 20px;
}
.estilos-listados-titulo div {
    padding: 10px;
}
.estilo-caja-collapse{
    width: 50%;
}
.estilos-listados {
    height: 110px;
    width: 60%;
    background-size: cover;
    background-position: center center;
    background-repeat: no-repeat;
    margin-bottom: 10px;
    margin-top: 10px;
}
.estilos-listados a div {
    padding: 10px;
}
.icon-boton{
    width: 100%;
    max-width: 200px
}
.icon-servicios{
    width: 100%;
    max-width: 45px;
}
#section-banner-services {
    min-height: 650px;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
   background-image: url("../assets/servicios/bannerServicios.png");
}
#section-banner-services .ajuste-textos {
    padding-top: 180px;
}
#section-frase{
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
}
@media (max-width: 540px) {
    #section-banner-services {
        min-height: 550px !important;
        /* background-image: url(../services/banner_mobile.png); */
    }

    .estilo-caja-collapse {
        width: 100% !important;
    }
}


    .clase-simbolo {
        width: 100%;
        max-width: 50px;
    }

    .clase-images {
        font-size: 25px;
        color: #ffffff;
    }

    #section-services {
        background-color: #f8fafd;
    }

    .estilos-listados-titulo {
        width: 65%;
        background-size: cover;
        background-position: center center;
        background-repeat: no-repeat;
        margin-bottom: 10px;
        margin-top: 10px;
        border-radius: 20px;
    }

        .estilos-listados-titulo div {
            padding: 10px !important;
        }

    .estilo-caja-collapse {
        width: 50%;
    }

    .estilos-listados {
        height: 110px;
        width: 60%;
        background-size: cover;
        background-position: center center;
        background-repeat: no-repeat;
        margin-bottom: 10px;
        margin-top: 10px 
    }

        .estilos-listados a div {
            padding: 10px;
        }

    .icon-boton {
        width: 100%;
        max-width: 200px;
    }

    .icon-servicios {
        width: 100%;
        max-width: 45px;
    }
</style>
